import { useEffect, useState } from 'react';
export default function useIsPWA() {
    var _a = useState(false), isPWA = _a[0], setIsPWA = _a[1];
    useEffect(function () {
        var isInStandaloneMode = function () {
            return window.matchMedia('(display-mode: standalone)').matches ||
                window.navigator.standalone ||
                document.referrer.includes('android-app://');
        };
        if (isInStandaloneMode()) {
            setIsPWA(true);
        }
    }, []);
    return isPWA;
}
